import { useTheme } from "@mui/material";
import React, { useState } from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ColorModeContext, tokens } from "../../../../theme";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import { ToastContainer, toast } from "react-toastify";

const TopMenuAgenticEUC = ({ onLanguageChange }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenLang, setIsOpenLang] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setIsOpenLang(false);
  };

  const toggleDropdownLanguage = () => {
    setIsOpenLang((prev) => !prev);
  };

  const handleLanguageChange = (language) => {
    onLanguageChange(language);
    setIsOpenLang(false);
  };

  const handleClickOutside = (event) => {
    if (!event.target.closest(".language-dropdown")) {
      setIsOpenLang(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const userRole = localStorage.getItem("role");
  const navigate = useNavigate();
  const handleLogout = () => {
    toast.error("You are Logged Out");
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      <div className="flex justify-between p-2 bg-white">
        <div className="d-flex align-items-center justify-content-between">
          <a href="./agentic-EUC" className="logo d-flex align-items-center">
            {
              <img
                src="https://ik.imagekit.io/ifixtechglobal/auto-Bot/image%201.png?updatedAt=1707214509024"
                alt=""
              />
            }
            <span className="d-none d-lg-block">GEN AI Agentic EUC</span>
          </a>
        </div>

        <div className="flex space-x-2 ml-auto">
          <button className="p-2">
            <a
              href="#"
              className="flex items-center pr-0"
              onClick={(e) => {
                e.preventDefault();
                toggleDropdown();
              }}
            >
              <PersonOutlinedIcon />
              <span className="hidden md:inline-block ml-2"></span>
            </a>

            {isOpen && (
              <ul
                className="absolute p-2 right-0 mt-2 w-48 border border-gray-200 rounded-lg shadow-lg"
                style={{ backgroundColor: colors.primary[400] }}
              >
                <li className="border-t border-gray-200"></li>
                <li
                  className="p-4 text-center list-none font-semibold text-red-600"
                  onClick={handleLogout}
                >
                  Logout
                </li>
              </ul>
            )}
          </button>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default TopMenuAgenticEUC;
